export default function distanceToString(distance, useKm = true) {
	if (distance < 1000 || !useKm) {
		return `${distance.toLocaleString('de-DE', { maximumFractionDigits: 1 })} m`;
	}
	return `${(distance / 1000).toLocaleString('de-DE', { maximumFractionDigits: 1 })} km`;
}
